import { session } from '@/components/helpers/session'
import { getSearchSpringDomain, getSearchSpringSiteID } from '../searchspring-utils'
import { cart } from '@/components/helpers/cart'
import { RANGE_INDICATOR } from '../components/FilterUtils'

/**
 * SearchspringParams
 * ---
 * Class designed to handle standardized formatting for any
 * URL manipulation SS might need for request building.
 * Extends on URLSearch Params.
 */

export class SearchspringParams extends URLSearchParams {
  params
  siteID
  domain

  constructor(category) {
    super()

    this.siteID = getSearchSpringSiteID(category)
    this.domain = getSearchSpringDomain(category)
  }

  // Local Params

  setSiteIDParam() {
    this.set('siteId', this.siteID)
    return this
  }

  setDomainParam() {
    this.set('domain', this.domain)
    return this
  }

  // Session Params

  setViewedProducts() {
    const viewedProducts = session.viewedProducts.get()
    if (viewedProducts) this.set('lastViewed', viewedProducts)
  }

  setShopperID() {
    const id = session.shopper.get()
    if (id) this.set('shopper', id)
  }

  setUserID() {
    const id = session.userId.get()
    if (id) this.set('userId', id)
  }
  // Window Params

  setCartItems() {
    const items = cart?.value?.items
    if (!items) return

    const skus = items.map((item) => item.sku).join(',')
    if (skus) this.set('cart', skus)
  }

  // General things

  setParams(params) {
    for (const [key, values] of Object.entries(params)) {
      this.set(key, values)
    }
    return this
  }

  setSort(sort) {
    // Remove previous sorting
    // For some reason, directly using this.keys() or this.entries() randomly misses last key
    const keys = Array.from(this.keys())
    for (const key of keys) {
      if (key.startsWith('sort')) {
        this.delete(key)
      }
    }

    // Add new sorting
    const [field, direction] = sort.split(':')
    const key = `sort.${field}`
    this.set(key, direction)
  }

  setFilters(filters) {
    // Remove previous filters
    // For some reason, directly using this.keys() or this.entries() randomly misses last key
    const keys = Array.from(this.keys())
    for (const key of keys) {
      if (key.startsWith('filter')) {
        this.delete(key)
      }
    }

    // Add new filters
    filters.forEach((filter) => {
      const [field, value] = filter.split(':')
      const key = `filter.${field}`

      // Aribitrary string delimiter that communicates this is a range
      // TODO: define this as a delimiter somewhere
      if (value.includes(RANGE_INDICATOR)) {
        const [low, high] = value.split(RANGE_INDICATOR)
        this.append(`${key}.low`, low)
        this.append(`${key}.high`, high)
        return
      }

      this.append(key, value)
    })

    return this
  }
}
